module.exports = __webpack_public_path__ + "img/couples-021.d428fb23.jpg";